import axios from "axios";
import { baseURL } from '../baseURL.js'

const ajax = axios.create({
  baseURL: baseURL // "https://dpinterface.djplus.cn",
  // baseURL: "http://192.168.2.247:29495",
});
// 拦截器
ajax.interceptors.request.use((config) => {
  // Loading.service({
  //   text: '加载中...'
  // })
  return config;
});

ajax.interceptors.response.use(
  (res) => {
    // 关闭提示加载的组件
    // const loadingInstance = Loading.service()
    // loadingInstance.close()
    if (res.data.code === 0 && res.status === 200) {
      return res.data;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default ajax;
